import { useEffect, useRef } from "react";
import { LogIn, PlayCircle } from "lucide-react";
import { useOnboarding } from "@/onboarding/context";

// PUBLIC WALKTHROUGH PAGES — no account needed. Each starts one replica walkthrough and, when it closes, hands the visitor to the sign-in home.
//  /how-strengthen-works → strengthen · /how-students-start → student · /how-teachers-work → teacher
const PAGES = {
  strengthen: { kicker: "Strengthen My Writing", title: "The \u2018Strengthen My Writing\u2019 Option: How It Works", lead: "A two-minute walkthrough of the pathway for writing that already exists \u2014 type it in, the whole, the paragraphs, the sentences, a final read, finished." },
  student: { kicker: "For students", title: "New Students: How to Begin", lead: "Sign in, join your teacher's course with a code, open an assignment, and choose how to write when you are working on your own." },
  teacher: { kicker: "For teachers", title: "The Teacher Dashboard: How It Works", lead: "Create a course and share its join code, set an assignment \u2014 including how students begin \u2014 read student work, give feedback and grades." },
};

export default function HowStrengthenWorks({ tour = "strengthen" }) {
  const onboarding = useOnboarding();
  const started = useRef(false);
  const wasActive = useRef(false);
  const page = PAGES[tour] || PAGES.strengthen;
  useEffect(() => { if (onboarding && !started.current) { started.current = true; setTimeout(() => onboarding.startReplica(tour), 150); } }, [onboarding, tour]);
  useEffect(() => {
    if (!onboarding) return;
    if (onboarding.active) wasActive.current = true;
    else if (wasActive.current) window.location.href = "/";                    // the walkthrough closed (finished or skipped): to the sign-in home
  }, [onboarding]);
  return (
    <div data-testid="how-strengthen-works" data-tour-page={tour} className="min-h-screen bg-[#faf9f6] text-stone-900">
      <header className="border-b border-stone-200 bg-white/80">
        <div className="mx-auto flex max-w-5xl items-center justify-between px-6 py-3">
          <a data-testid="hsw-home" href="/" className="font-serif-display text-lg text-stone-900">The Writing Studio</a>
          <a data-testid="hsw-signin" href="/" className="inline-flex items-center gap-1.5 text-[13px] font-medium text-[#8C3A2A] hover:underline"><LogIn className="h-4 w-4" /> Sign in</a>
        </div>
      </header>
      <main className="mx-auto max-w-3xl px-6 py-16">
        <p className="font-mono-panel text-[10px] uppercase tracking-[0.22em] text-[#8C3A2A]">{page.kicker}</p>
        <h1 className="font-serif-display text-4xl sm:text-5xl text-stone-900 mt-2">{page.title}</h1>
        <p className="text-[16px] text-stone-700 mt-4 max-w-xl">{page.lead}</p>
        <button data-testid="hsw-start" onClick={() => onboarding?.startReplica(tour)} className="mt-8 inline-flex items-center gap-2 bg-[#8C3A2A] text-white text-[15px] font-medium px-6 py-3 rounded-md hover:bg-[#6B2C20]"><PlayCircle className="h-5 w-5" /> Start the walkthrough</button>
      </main>
    </div>
  );
}
